import { useQuery } from '@tanstack/react-query';
import { useApiMutation } from '../../api/mutations';
import { nexusFetch } from '../../nexus/nexusClient';
import { useFixturesMode, fixtureDelay } from '../../api/fixtures';
import { nexusSettingsFixture, applyNexusSettingPatch } from './fixture';

/**
 * Spec: lmm-wiki/wiki/orbit-specs/nexus-system-settings.md
 * Endpoints: /v1/admin/settings (GET), /v1/admin/settings/:key (PUT)
 */

/** GET /v1/admin/settings */
export function useNexusSettings() {
  const fixturesMode = useFixturesMode();
  return useQuery({
    queryKey: ['nexus-settings', fixturesMode ? 'fixture' : 'live'],
    queryFn: async () => {
      if (fixturesMode) {
        await fixtureDelay();
        return nexusSettingsFixture();
      }
      const res = await nexusFetch('/v1/admin/settings');
      // Toleriert: {settings:[...]}, {items:[...]}, direkt array
      const list = res?.settings ?? res?.items ?? (Array.isArray(res) ? res : []);
      return { settings: list, raw: res };
    },
    staleTime: 30_000,
  });
}

/** PUT /v1/admin/settings/:key — `{ value }` */
export function useSetNexusSetting() {
  return useApiMutation({
    live: (_fetch, { key, value }) =>
      nexusFetch(`/v1/admin/settings/${encodeURIComponent(key)}`, {
        method: 'PUT',
        body: { value },
      }),
    fixture: ({ key, value }) => {
      applyNexusSettingPatch(key, value);
      return { ok: true, key, value };
    },
    invalidate: ['nexus-settings'],
    successMessage: (_, { key }) => `${key} gespeichert.`,
  });
}
